import {
  Button,
  Div,
  ErrorToast,
  H3,
  Modal,
  ModalIconStyle,
  P,
  SuccessToast,
  TrashIcon,
  UserRole,
  Wallets,
  deleteBank,
  deleteBankLocation,
  reportError,
} from '@vgrubs/components';

export const UserCreditCardDelete = ({
  userId,
  deleteBankModal,
  setDeleteBankModal,
  getBank,
  wallet,
  setLoading,
  userRole,
}: {
  userId: string | number | undefined;
  deleteBankModal: Wallets | boolean | null;
  setDeleteBankModal: (value: Wallets | boolean | null) => void;
  getBank: () => void;
  wallet?: Wallets;
  setLoading: (v: boolean) => void;
  userRole: UserRole;
}) => {
  async function handleDeleteBank() {
    if (!userId) {
      return ErrorToast('User ID is required');
    }

    const chooseApi =
      userRole === UserRole.partner ? deleteBankLocation : deleteBank;

    try {
      setLoading(true);
      const { data } = await chooseApi(userId, wallet?.simpleLocation?.id);
      await getBank();
      SuccessToast(data.message);
      setDeleteBankModal(null);
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={!!deleteBankModal}
      closeModal={() => setDeleteBankModal(null)}
      logo={false}
    >
      <Div $flex $justifyCenter>
        <ModalIconStyle>
          <TrashIcon />
        </ModalIconStyle>
      </Div>
      <H3 $mb="8">Delete Bank Account?</H3>
      <P $mb="16">
        Are you sure tou want to delete this bank account? This cannot be
        undone.
      </P>

      <Div $flex $gap="20px">
        <Div $width="50%">
          <Button $selected $w="100%" $mt="24" onClick={handleDeleteBank}>
            Yes
          </Button>
        </Div>
        <Div $width="50%">
          <Button
            $selected
            $gray
            $w="100%"
            $mt="24"
            onClick={() => setDeleteBankModal(null)}
          >
            No
          </Button>
        </Div>
      </Div>
    </Modal>
  );
};
